module.exports = __webpack_public_path__ + "static/media/fiesta-senorita@2x.2e460126.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/fiesta-senorita@2x.png
// module id = 1356
// module chunks = 1